import React from "react";

import Layout from "../../layouts/Layout";
import Hero from '../../layouts/main/Hero';
import Main from "../../layouts/main/Main";


const Home = () => {
  return (
    <Layout >
   
        <Hero />
        <Main />  
    
    </Layout>
  );
};

export default Home;
